import script from "./AlbumShareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlbumShareModal.vue?vue&type=script&setup=true&lang=ts"

import "./AlbumShareModal.vue?vue&type=style&index=0&id=32af964a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32af964a"]])

export default __exports__